import React from 'react';

// Shared brand decorations used by the landing hero and the auth page.

// Hand-drawn style decorations from the hero composition.
export const Squiggle = ({ className = '' }) => (
  <svg viewBox="0 0 120 60" fill="none" className={className} aria-hidden="true">
    <path
      d="M4 8c18 4 40 14 58 30 8 7 18 12 22 4 3-7-7-12-11-5-4 8 8 16 20 12 9-3 16-10 22-18"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const Sparkle4 = ({ className = '' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 2c.6 5.2 4.8 9.4 10 10-5.2.6-9.4 4.8-10 10-.6-5.2-4.8-9.4-10-10 5.2-.6 9.4-4.8 10-10z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

// Soft blue blob that sits behind the shield logo.
export const HeroBlob = ({ className = '' }) => (
  <svg viewBox="0 0 500 500" className={`absolute inset-0 w-full h-full dark:opacity-25 ${className}`} aria-hidden="true">
    <defs>
      <linearGradient id="heroBlob" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#B8CEF7" stopOpacity="0.85" />
        <stop offset="100%" stopColor="#DAE6FC" stopOpacity="0.5" />
      </linearGradient>
    </defs>
    <path
      fill="url(#heroBlob)"
      d="M391 88c47 42 72 108 62 169s-56 118-116 147-133 30-190 0S51 318 44 256 64 128 111 86 213 20 277 26s67 20 114 62z"
    />
  </svg>
);

// Blue & gold backdrop shared by every page (rendered once in App.js).
// It drifts only on the landing page; elsewhere it stays still so busy
// dashboards don't pay for a constantly animating layer.
export const MeshBackground = ({ animated = false }) => (
  <div className={`liquid-mesh-bg${animated ? '' : ' is-static'}`} aria-hidden="true">
    <span /><span /><span /><span />
  </div>
);
